import { render, staticRenderFns } from "./questionnaire.vue?vue&type=template&id=5d553e64&scoped=true"
import script from "./questionnaire.vue?vue&type=script&lang=js"
export * from "./questionnaire.vue?vue&type=script&lang=js"
import style0 from "./questionnaire.vue?vue&type=style&index=0&id=5d553e64&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d553e64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d553e64')) {
      api.createRecord('5d553e64', component.options)
    } else {
      api.reload('5d553e64', component.options)
    }
    module.hot.accept("./questionnaire.vue?vue&type=template&id=5d553e64&scoped=true", function () {
      api.rerender('5d553e64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/questionnaire/questionnaire.vue"
export default component.exports